/**
 * Shared error surface used on data-heavy pages (Cash Flow, Lifestyle,
 * Investment Committee, etc.) so any 401 / 500 / network hiccup shows a
 * diagnosable message instead of an eternal "Loading…" spinner.
 *
 * Usage:
 *   const [error, setError] = useState(null);
 *   api.get("/foo").then(setData).catch(e => setError(parseApiError(e)));
 *   if (error) return <ErrorCard error={error} onRetry={reload} />;
 */

export function parseApiError(err) {
    if (err?.response?.status === 401) return "auth";
    return err?.response?.data?.detail || err?.message || "network";
}

export function ErrorCard({ error, onRetry, subject = "this page", testId = "page-error" }) {
    const msg = error === "empty"
        ? `No data available yet for ${subject}. Import transactions or add records first.`
        : error === "auth"
        ? "Your session expired. Please sign out and back in."
        : `Couldn't load ${subject}: ${error}. This is usually a transient network hiccup.`;
    return (
        <div className="p-8" data-testid={testId}>
            <div className="hairline bg-white p-6 rounded max-w-2xl">
                <div className="label-eyebrow mb-2 text-[var(--terracotta)]">
                    {subject.charAt(0).toUpperCase() + subject.slice(1)} unavailable
                </div>
                <div className="text-sm mb-4">{msg}</div>
                <button onClick={onRetry || (() => window.location.reload())}
                        data-testid={`${testId}-retry`}
                        className="btn-primary text-sm">
                    Retry
                </button>
            </div>
        </div>
    );
}
